/**
 * Binds {@link buildApprovedFormOptions} to the three version queries, the way `usePlanningStepperFormStatuses` binds
 * the rail's statuses. The decision itself stays pure and testable next door.
 */

import { useMemo } from 'react';

import { useWorkAssignmentListAttachments } from '../hooks/assignmentListHooks';
import { useIcs215ExistingTip } from '../hooks/ics215FormVersionHooks';
import { useFormVersionTipsForPeriod } from '../hooks/icsFormVersionHooks';
import { buildApprovedFormOptions } from './approvedFormOptions';
import type { CardOption } from './cardOptions';

export function useApprovedFormsForPeriod(periodNumber: number): CardOption[] {
  const { data: tips = [] } = useFormVersionTipsForPeriod(periodNumber);
  const { data: tip215 = null } = useIcs215ExistingTip(periodNumber);
  const { data: walas = [] } = useWorkAssignmentListAttachments();

  return useMemo(
    () =>
      buildApprovedFormOptions({
        tips,
        tip215,
        walas,
        workingPeriodNumber: periodNumber,
      }),
    [tips, tip215, walas, periodNumber]
  );
}
